module.exports = __webpack_public_path__ + "img/marco-arana.8a2c5d06.png";